/**
 * collaborator-panel.component.ts
 * Copyright © 2016-2018, My Coverage Plan, Inc.
 * All rights reserved.
 */

/**
 * @author Taylor DH Smith <tdsmith@safetyweb.org>
 */

import { Component, Input, OnInit } from "@angular/core";

import { MessagingService } from "../server/messaging.service";
import { CollaborationService } from "./collaboration.service";

/**
 * A {@link CollaboratorPanelComponent} presents a list of collaborating users
 * connected to the current resource (e.g. a subject context).
 */
@Component({
  selector: "collaborator-panel",
  template: `
    <div
      class="panel panel-default fade"
      [class.in]="!hideWhenEmpty || users.length">
      <div class="panel-heading" (click)="panelOpen = !panelOpen">
        <h3 class="panel-title">
          Editing this subject
          <span class="badge">{{collaboration.users.length || 0}}</span>
        </h3>
      </div>
      <table class="user-list text-center collapse"
      [class.in]="panelOpen">
        <tr *ngFor="let user of collaboration.users">
          <td class="h3">
            <span class="glyphicon glyphicon-user"></span>
          </td>
          <td>
            <strong>{{user.name}}</strong>
            <span
              *ngIf="user.userId.length > 1"
              class="text-info"
              title="This user has multiple active tabs or windows open.">
              <br>({{user.userId.length}} connections)
            </span>
          </td>
          <td>
            <em>{{user?.org || "Unknown organization"}}</em>
          </td>
        </tr>
        <tr *ngIf="!collaboration?.users?.length">
          <td colspan="3">No one is accessing this document.</td>
        </tr>
      </table>
    </div>
`,
  styles: [
    `.user-list {
      width: 100%;
      padding: 0.5em;
    }`,
    ".user-list.collapse.in { display: table; }",
    ".user-list td:first-child { padding: 10px; }"
  ]
})
export class CollaboratorPanelComponent implements OnInit
{
  @Input()
  public startOpen : boolean;

  /**
   * Whether the body of the panel is open or collapsed.
   */
  public panelOpen : boolean = this.startOpen || false;

  @Input()
  public openOnChanges : boolean = false;

  /**
   * Construct a new {@link CollaboratorPanelComponent}.
   *
   * @param messaging
   *        The {@link MessagingService}
   */
  constructor (
    private messaging : MessagingService,
    private collaboration : CollaborationService
  )
  {
    /* Nothing. */
  }

  /**
   * Arrange to receive updates about collaborating {@link User}s from the
   * {@link CollaboratorService}.
   */
  public ngOnInit () : void
  {
    this.collaboration.userEvents.subscribe((changes : boolean) => {
      if (this.openOnChanges && changes)
      {
        this.panelOpen = true;
      }
    });
  }
}



// WEBPACK FOOTER //
// ./~/angular-router-loader/src!./app/intake-form/collaborator-panel.component.ts